import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { applyStakeholdersSearchCriteria, clearStakeholdersSearchCriteria } from "domains/stakeholders/actions";
import { getStakeholdersSearchCriteria } from "domains/stakeholders/selectors";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";

export const TopicStakeholderFilterModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const searchCriteria = useSelector(getStakeholdersSearchCriteria);
  const filters = useSelector(getTopicFilters("stakeholders"));

  return (
    <TopicFilterModal
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyStakeholdersSearchCriteria(payload))}
      handleClear={() => dispatch(clearStakeholdersSearchCriteria())}
      searchCriteria={searchCriteria}
      title={translate("app.stakeholders.filter.title")}
    />
  );
};
